import { useEffect } from 'react'
import type { CommandAction } from '../CommandPalette'

const matchesShortcut = (event: KeyboardEvent, shortcut: string[]) => {
  if (!shortcut.length) return false
  const normalized = shortcut.map((key) => key.toLowerCase())
  const mainKey = normalized[normalized.length - 1]
  const modifiers = new Set(normalized.slice(0, -1))
  const metaViaCtrl = !event.metaKey && event.ctrlKey
  const modifierState = {
    meta: event.metaKey || metaViaCtrl,
    ctrl: event.ctrlKey && !metaViaCtrl,
    shift: event.shiftKey,
    alt: event.altKey,
  }
  for (const [name, pressed] of Object.entries(modifierState) as Array<[keyof typeof modifierState, boolean]>) {
    const required = modifiers.has(name)
    if (required !== pressed) return false
  }
  const key = event.key.toLowerCase()
  return key === mainKey
}

export const useCommandShortcuts = (
  actions: CommandAction[],
  isAuthenticated: boolean,
  togglePalette: (updater: (prev: boolean) => boolean) => void,
) => {
  useEffect(() => {
    const handleKeyDown = (event: KeyboardEvent) => {
      if ((event.metaKey || event.ctrlKey) && event.key.toLowerCase() === 'k') {
        event.preventDefault()
        if (!isAuthenticated) return
        togglePalette((prev) => !prev)
        return
      }

      for (const action of actions) {
        if (action.shortcut && matchesShortcut(event, action.shortcut)) {
          event.preventDefault()
          action.perform?.()
          break
        }
      }
    }

    window.addEventListener('keydown', handleKeyDown)
    return () => {
      window.removeEventListener('keydown', handleKeyDown)
    }
  }, [actions, isAuthenticated, togglePalette])
}
